import axios from "axios";
import configData from "../config/config";
import { configKeys, userKeys } from "./Constant";

// Method use to make api request to aws
const getConfigurations = async (pageSize, pageToken = "", searchString = "", filterOption = "") => {
  // TODO: Logging framework to be added in future.
  let url = `${configData.API_URL}/configs?pageSize=${pageSize}`;
  const selectedFilterOption = Array.isArray(filterOption)
    ? filterOption
    : typeof filterOption === "string" && filterOption
    ? [filterOption]
    : [];

  let configFilters = [];
  let userFilters = [];

  // To send all filter option in payload if no filter option is selected
  if (searchString && selectedFilterOption?.length === 0) {
    configFilters = [...configKeys];
    userFilters = [...userKeys];
  } else {
    configFilters = selectedFilterOption.filter((key) => configKeys.includes(key));
    userFilters = selectedFilterOption.filter((key) => userKeys.includes(key));
  }
  if (searchString && configFilters.length > 0) {
    url += `&configFilterOption=${configFilters.join(",")}`;
  }
  if (searchString && userFilters.length > 0) {
    url += `&userFilterOption=${userFilters.join(",")}`;
  }
  if (searchString) {
    url += `&searchString=${encodeURIComponent(searchString)}`;
  }
  if (pageToken) {
    url += `&id=${pageToken}`;
  }
  const res = await axios({
    method: "GET",
    url,
  });
  return res;
};

const getReportData = async (configId) => {
  const url = `${configData.API_URL}/configs/${configId}/calculate`;
  const res = await axios({
    method: "POST",
    url,
  });
  return res;
};
const getSystemTypes = async () => {
  const url = `${configData.API_URL}/standards`;
  const res = await axios({
    method: "GET",
    url,
  });
  return res;
};

// used for get system types from the localstorage
const getStandardListFromLocalStorage = () => {
  if (localStorage.key("standardList")) {
    return JSON.parse(localStorage.getItem("standardList"));
  }
  return null;
};

// used for get system types from the localstorage
const getFooterListFromLocalStorage = () => {
  if (localStorage.key("footerList")) {
    return JSON.parse(localStorage.getItem("footerList"));
  }
  return null;
};

// Statistics API
const getStatisticData = async (startDate, endDate) => {
  let url = `${configData.API_URL}/users/stats`;
  if (startDate) {
    url = `${configData.API_URL}/users/stats?fromDate=${startDate}&toDate=${endDate}`;
  }
  const res = await axios({
    method: "GET",
    url,
  });
  return res;
};
const ConfigService = {
  getConfigurations,
  getReportData,
  getSystemTypes,
  getStandardListFromLocalStorage,
  getFooterListFromLocalStorage,
  getStatisticData,
};

export default ConfigService;
